import Pagination from './Pagination';
import BaseDialog from '../common/base-dialog.vue';



export default {
  install (Vue) {
    //注册全局组件
    Vue.component('Pagination', Pagination)
    Vue.component('BaseDialog', BaseDialog)
  }
}